export enum NotificationType {
    EmailWithPdf = 'EMAIL_WITH_PDF',
    EmailWithXml = 'EMAIL_WITH_XML',
    EmailWithPdfAndXml = 'EMAIL_WITH_PDF_AND_XML',
}

export const getNotificationTypeTranslationId = (notificationType: NotificationType) => {
    return `app.enum.notificationType.${notificationType}`;
};
